import React from 'react';
import { Card, Col, Image } from 'react-bootstrap';
import '../css sheets/about.css'
import 'bootstrap/dist/css/bootstrap.min.css';

function About() {
  return (
    <div className='custom-about-div'>
      <span className='header-span'>About Me</span>
        <Card className="custom-about-card">
        <Card.Body>
          <div className="about-content">
              <img src="Ice.jpg" className='about-image' ></img>
            <Card.Text className='about-card-text'>
            <h4>Hello, my name is Andrew Thomas,</h4> I’m an American currently based out of Seoul, South Korea. I was born in Buffalo, NY but spent the majority of my time growing up in Sierra Vista, Arizona. I graduated from Northern Arizona University in 2019 with a Bachelors of Science in Geology. As a student I was lucky enough to spend two semesters at Korea University in Seoul on a study abroad program. This was a wonderful experience for me and led me to return to Seoul as a teacher after my graduation. Six months into my first teaching job I discovered a fascination with programming almost by accident. I was tinkering with Excel in the hopes of optimizing some administrative tasks and long story short Google brought it to my attention that Python would be a phenomenal tool for that end. I dove right into Python tutorials on YouTube and quickly realized I wanted to pursue a career in technology. After a year of self-study and exploration of different fields and technologies like data science, AWS, and machine learning I decided to enroll in the MITxpro Full Stack Developer course in February 2021. The course spanned 32 weeks and really force-marched my abilities in web development. Since the completion of the course in November 2021 I have been pursuing some personal projects and ideas and developing myself further. I'm eager to take the next step and put my skills into practice professionally.
            </Card.Text>
          </div>
        </Card.Body>
      </Card>

    </div>
  );
}

export default About;
